





















































































































































































































































































































































import { FieldInterface, StatementsInterface } from "@/types.d.ts";
import { SET_PROGRESS } from "@/constants/mutation-types";
import { DataHelper } from "@/helpers/DataHelper";
import { Locale } from "@/constants/locale";
import Select from "@/components/basic/fields/Select.vue";
import Radio from "@/components/basic/fields/Radio.vue";
import CheckBox from "@/components/basic/fields/CheckBox.vue";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import Vue from "vue";
import Popup from "@/components/basic/Popup.vue";
import Field from "@/components/basic/fields/Field.vue";
import i18n from "@/i18n";
import { DataUserDeclaration } from "@/constants/form-values";

export default Vue.extend({
  name: "DeclarationAcceptance",
  data() {
    return {
      i18n,
      Locale,
      DataUserDeclaration,
      formData: {
        usaTaxPayer: null as null | boolean,
        pepDeclaration: null as null | boolean,
        investmentGoal: "",
        incomeSource: "",
        documentsAcceptance: false,
        usaTin: "",
        confirmElectronicAgreement: false,
        dataUserDeclaration: "",
        receivedKid: false,
        receivedKidLabel: "",
        understoodFeaturesAndRisks: false,
        understoodFeaturesAndRisksLabel: "",
        awareOfLossAndCreditRisks: false,
        awareOfLossAndCreditRisksLabel: "",
      } as StatementsInterface,
      purposeContract: [] as FieldInterface[],
      sourceEarnings: [] as FieldInterface[],
      isOpenInformationForUsTaxPayer: false,
      isOpenInformationForPoliticallyExposedPerson: false,
      isOpenDataUserDeclarationInfo: false,
      formIsValid: false,
      showDocuments: false,
      TRANSLATION_KEY: "steps.DeclarationAcceptance",
    };
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 4);
    this.loadJSONData();
    // @ts-ignore
    if (this.$refs.receivedKidRef) {
      // @ts-ignore
      this.formData.receivedKidLabel = this.$refs.receivedKidRef.textContent.trim();
    }
    // @ts-ignore
    if (this.$refs.understoodFeaturesRisksRef) {
      // @ts-ignore
      this.formData.understoodFeaturesAndRisksLabel = this.$refs.understoodFeaturesRisksRef.textContent.trim();
    }
    // @ts-ignore
    if (this.$refs.awareOfLossRisksRef) {
      // @ts-ignore
      this.formData.awareOfLossAndCreditRisksLabel = this.$refs.awareOfLossRisksRef.textContent.trim();
    }
    this.isValid()
    setInterval(this.isValid, 100)
  },
  methods: {
    popupHandle(dataInfo: string): void {
      if (dataInfo.indexOf("usTaxPayer") > -1) {
        this.isOpenInformationForUsTaxPayer = !this.isOpenInformationForUsTaxPayer;
      } else {
        this.isOpenInformationForPoliticallyExposedPerson = !this.isOpenInformationForPoliticallyExposedPerson;
      }
    },
    loadJSONData() {
      DataHelper.loadJSON(i18n.locale).then(data => {
        Object.entries(data).forEach(([key, value]) => {
          if (key === "purposeContract") {
            // @ts-ignore
            this.purposeContract = value;
          }
          if (key === "sourceEarnings") {
            // @ts-ignore
            this.sourceEarnings = value;
          }
        });
      });
    },
    otherThanPLAndEN() {
      return !(i18n.locale.toUpperCase() === "PL" || i18n.locale.toUpperCase() === "EN");
    },
    isValid() {
      let checkboxWrapper = document.querySelector('.declaration-step-checkbox-wrapper')
      if(checkboxWrapper) {
        const checkboxes = checkboxWrapper.querySelectorAll('input[type="checkbox"]');
        const checkedCheckboxes = checkboxWrapper.querySelectorAll('input[type="checkbox"]:checked');
        this.formIsValid = checkboxes.length === checkedCheckboxes.length;
      }

    }, 
    documentsShow() {
      this.showDocuments = !this.showDocuments
    } 
  },
  watch: {
    "formData.usaTaxPayer"() {
      this.formData.usaTin = ''
    },
    "formData.downloadAll"(newValue) {
      if(newValue) {
        const zipLink = document.querySelector('.download-all-link');
        if(zipLink) {
          const url = zipLink.getAttribute('href');
          if(url) {
            window.open(url, '_parent');
          }
        }
      }
    }
  },
  components: {
    CheckBox,
    Radio,
    Select,
    SubmitButton,
    Popup,
    Field,
  },
});
